import React, { Component } from "react";
import { Link } from "react-router-dom"

import { generalS } from "../../strings/general";
import { baseStyles } from "../baseStyles";
import LoadingScreen from "react-loading-screen";
import Footer from "../footer/Footer";
// import Header from "../header/Header";
import AOS from 'aos';

import 'aos/dist/aos.css';
import "../../styles/css/project.css";
import "../../styles/css/main.css";
import "../../styles/css/home.css";

import { url } from '../../inv';

class ProjectsMain extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { context, latestPosts, title, footerText } = this.props;
    let { language } = context;
    return (
      <div style={{ height: "100%" }}>
        <div className={"wrapper"}>
          <div className={"project-section-main"}>
            <div className={"home-calender-title"}>
              <span>
                {title ? title : ("")}
              </span>
            </div>
            {latestPosts && latestPosts.length > 0 ?
              <div className={"project-card-large"}>
                {latestPosts[0].fileNames[0] ?
                  <div className={"project-card-image-content"}>
                    <img src={`${url}/public/${latestPosts[0].fileNames[0]}`} />
                  </div>
                  : ("")}
                <div className={"project-card-contener"}>
                  {latestPosts[0].data.value.title ?
                    <h2 className={"project-card-title"}>{latestPosts[0].data.value.title}</h2>
                    : ("")}
                  {latestPosts[0].data.value.subTitle ?
                    <h3>{latestPosts[0].data.value.subTitle}</h3>
                    : ("")}
                  {latestPosts[0].data.value.details.length > 0 ?
                    latestPosts[0].data.value.details.map((d, i) => {
                      if (i < 2)
                        return (
                          <p className={"project-card-detail"}>{d}</p>
                        )
                    })
                    : ("")}
                  {latestPosts[0].data.value.details.length > 0 ?
                    <div className={"project-card-link-content"}>
                      <Link to={`/detail?${latestPosts[0].postId}`} className={"home-card-link"}>
                        {generalS.readMore[language]}
                      </Link>
                    </div>
                    : ("")}
                </div>
              </div>
              : ("")}
          </div>
        </div>
        <div className={"wrapper-big"}>
          {latestPosts && latestPosts.length > 0 ?
            <div>
              <div className={"project-sub-section"}>
                {latestPosts[1] ?
                  <div className={"project-card-mediume"}>
                    <div className={"project-card-image-content"}>
                      {latestPosts[1].fileNames[0] ?
                        <div className={"project-card-image-content"}>
                          <img src={`${url}/public/${latestPosts[1].fileNames[0]}`} />
                        </div>
                        : ("")}
                      <div className={"project-card-contener"}>
                        {latestPosts[1].data.value.title ?
                          <h2 className={"project-card-title"}>{latestPosts[1].data.value.title}</h2>
                          : ("")}
                        {latestPosts[1].data.value.subTitle ?
                          <h3>{latestPosts[1].data.value.subTitle}</h3>
                          : ("")}
                        {latestPosts[1].data.value.details.length > 0 ?
                          <p className={"project-card-detail"}>{latestPosts[1].data.value.details[0]}</p>
                          : ("")}
                        <div className={"project-card-link-content"}>
                          <Link to={`/detail?${latestPosts[1].postId}`} className={"home-card-link"}>
                            {generalS.readMore[language]}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  : ("")}
                {latestPosts[2] ?
                  <div className={"project-card-mediume"}>
                    {latestPosts[2].fileNames[0] ?
                      <div className={"project-card-image-content"}>
                        <img src={`${url}/public/${latestPosts[2].fileNames[0]}`} />
                      </div>
                      : ("")}
                    <div className={"project-card-contener"}>
                      {latestPosts[2].data.value.title ?
                        <h2 className={"project-card-title"}>{latestPosts[2].data.value.title}</h2>
                        : ("")}
                      {latestPosts[2].data.value.subTitle ?
                        <h3>{latestPosts[2].data.value.subTitle}</h3>
                        : ("")}
                      {latestPosts[2].data.value.details.length > 0 ?
                        <p className={"project-card-detail"}>{latestPosts[2].data.value.details[0]}</p>
                        : ("")}
                      <div className={"project-card-link-content"}>
                        <Link to={`/detail?${latestPosts[2].postId}`} className={"home-card-link"}>
                          {generalS.readMore[language]}
                        </Link>
                      </div>
                    </div>
                  </div>
                  : ("")}
              </div>
              <div className={"project-sub-section"}>
                {latestPosts.map((e, i) => {
                  if (i > 2)
                    return (
                      <div className={"project-card-small"}>
                        {e.fileNames[0] ?
                          <div className={"project-card-image-content"}>
                            <img src={`${url}/public/${e.fileNames[0]}`} />
                          </div>
                          : ("")}
                        <div className={"project-card-contener"}>
                          {e.data.value.title ?
                            <h2 className={"project-card-title"}>{e.data.value.title}</h2>
                            : ("")}
                          {e.data.value.subTitle ?
                            <h3>{e.data.value.subTitle}</h3>
                            : ("")}
                          {e.data.value.details.length > 0 ?
                            <p className={"project-card-detail"}>{e.data.value.details[0]}</p>
                            : ("")}
                          <div className={"project-card-link-content"}>
                            <Link to={`/detail?${e.postId}`} className={"home-card-link"}>
                              {generalS.readMore[language]}
                            </Link>
                          </div>
                        </div>
                      </div>
                    )
                })}
              </div>
            </div>
            : ("")}
        </div>
        <div className={"wrapper"}>
          <Footer context={context} footerText={footerText} />
        </div>
      </div>
    );
  }
}

export default ProjectsMain;
